import { defineNuxtPlugin } from '#app';
import ScrollSpy from 'bootstrap/js/dist/scrollspy';

export default defineNuxtPlugin(() => {
  return {
    provide: {
      scrollSpy: (element: Element, options?: Partial<ScrollSpy.Options>) =>
        new ScrollSpy(element, options || {}),
    },
  };
});
